import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArcaptchaWidget,
  ArcaptchaWidgetHandle,
} from "arcaptcha-react";
import Button from "../Components/Button";
import TextInput from "../Components/TextInput";
import { login } from "../Requests/authRequests";
import { arcaptchaSiteKey, shouldShowArcaptcha } from "../Requests/config";
import Loading from "../Components/Loading/Loading";
import { checkTokenValidation, isCustomerUser, setIsCustomer } from "../helper";
import { toast } from "react-toastify";
import payaLogo from "../Assets/Images/payaLogo.png";
import packageJson from "../../package.json";

export interface ILoginFromValues {
  username: string;
  password: string;
}

const Login = () => {
  const [formValues, setFormValues] = React.useState<ILoginFromValues>(
    {} as ILoginFromValues,
  );
  const [arcaptchaToken, setArcaptchaToken] = useState("");
  const [loading, setLoading] = useState(false);
  const arcaptchaRef = useRef<ArcaptchaWidgetHandle>(null);
  const showArcaptcha = shouldShowArcaptcha();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (checkTokenValidation()) {
      navigate(isCustomerUser() ? "/iMEPortfolio" : "/sahra_user");
    }
  }, []);

  const clearCaptchaToken = () => {
    setArcaptchaToken("");
  };

  const resetCaptchaWidget = () => {
    if (!showArcaptcha) return;
    arcaptchaRef.current?.resetCaptcha();
    clearCaptchaToken();
  };

  const changeHandler = (name: string, value: string) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const checkDisabled = () => {
    if (!formValues) return true;
    if (!formValues.username || !formValues.password) return true;
    return false;
  };

  const btnClickHandler = () => {
    setLoading(true);
    login({
      username: formValues.username,
      password: formValues.password,
      ...(showArcaptcha ? { arcaptchaToken } : {}),
    })
      .then((res) => {
        localStorage.setItem("token", `Bearer ${res.token}`);
        localStorage.setItem("expiration", res.expiration.toString());
        setIsCustomer(res.isCustomer);
        navigate(res.isCustomer ? "/iMEPortfolio" : "/sahra_user");
      })
      .catch((e) => {
        const errorMsg = e.response?.data?.msg;
        if (errorMsg) toast.error(errorMsg);
        else toast.error("خطا در ارتباط با سرور");
        resetCaptchaWidget();
      })
      .finally(() => setLoading(false));
  };

  const enterPressHandler = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter") if (!checkDisabled()) btnClickHandler();
  };

  if (loading)
    return (
      <div className="h-screen w-full flex flex-col justify-center items-center">
        <Loading />
      </div>
    );

  return (
    <div className="h-screen w-full flex flex-col justify-center items-center">
      <form
        onKeyDown={enterPressHandler}
        className="w-96 bg-white flex flex-col justify-start items-center gap-2 p-5 border-sky-600	border-2 shadow-md rounded"
      >
        <img src={payaLogo} alt="پایا الگوریتم" className="w-44 h-44" />
        <TextInput
          label="نام کاربری"
          name="username"
          value={formValues.username}
          onChange={changeHandler}
          classname="my-3"
          autoFocus
        />
        <TextInput
          type="password"
          label="کلمه عبور"
          name="password"
          value={formValues.password}
          onChange={changeHandler}
          classname="mb-3"
        />
        {showArcaptcha ? (
          <div className="w-full flex justify-center my-2">
            <ArcaptchaWidget
              ref={arcaptchaRef}
              site-key={arcaptchaSiteKey()}
              lang="fa"
              theme="light"
              callback={(token) => setArcaptchaToken(token ?? "")}
              expired_callback={clearCaptchaToken}
              chlexpired_callback={clearCaptchaToken}
              reset_callback={clearCaptchaToken}
            />
          </div>
        ) : null}
        <Button
          className="mt-4"
          onClick={btnClickHandler}
          text="ورود"
          variant="contained"
          disabled={checkDisabled()}
        />
      </form>
      <div className="fixed bottom-5 left-5 text-xs">{packageJson.version}</div>
    </div>
  );
};

export default Login;
